import React from 'react';
import {
  Header,
  Button,
  Icon
} from 'semantic-ui-react';

const AddHeader = (props) => {
  const {
    headerText,
    showForm,
    onClick,
  } = props;

  let { size, subheader } = props;

  !size ? size = 'h1' : null;
  !subheader ? subheader = '' : null;

  let buttonText = headerText;

  if (headerText === 'Salespeople') {
    buttonText = 'Salesperson';
  }

  if (buttonText[buttonText.length - 1] === 's') {
    buttonText = buttonText.substring(0, buttonText.length - 1);
  }

  const addButtonText = !showForm ? `Add ${buttonText}` : 'Close';

  return (
    <div>
      <Header
        as={size}
        content={props.headerText}
        subheader={subheader}
        dividing={subheader ? true : false}
      />
      <div className="add-button-container">
        <Button
          color={!showForm ? 'blue' : 'red'}
          onClick={onClick}
        >
          <Icon name={!showForm ? 'plus circle' : 'remove circle'}/>
          {addButtonText}
        </Button>
      </div>
    </div>
  );
};

export default AddHeader;
